import React, { Component } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Box,
  HStack,
  FormControl,
  FormLabel,
  Select,
  Text,
  Center
} from "@chakra-ui/react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import changeLogArchive from "../../changelogArchive";



export default class ChangeHistoryPage extends Component 
{
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true
    };



  }


  render() {
    return (

        <div className='main'>
          <Box bgColor='#0a597e' borderRadius='5px' width='100%' padding='20px'>

            <Text fontSize={{ base: '30px', md: '36px', lg: '40px' }} color='white'>Change History</Text>
              <Box>
              <div>
                {changeLogArchive.map((version) => {
                  return <div style={{ color: "white", fontSize: "14pt" }} key={version.version}>Version {version.version}
                    {version.issues.map(issue => {
                      return <div style={{ color: "lightgrey", fontSize: "12pt" }} key={issue.id}>{issue.id}-{issue.description}</div>
                    })}
                    <br />
                  </div>
                })}

              </div>
              </Box>
          </Box>
        </div>
    );
  }
}
